import { FC, useEffect, useState } from "react";
import { useChatStore } from "../../stores/ChatStore";
import moment from "moment";
import useUser from "../../hooks/User";
import { formatText } from "../../functions/general";
import { ChatWindowData } from "../../interfaces/Chat/ChatWindowData";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { focusChatInput, isShowChatRoom } from "../../functions/chat";
import { useSettingsStore } from "../../stores/SettingsStore";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import BadgeTooltip from "../General/BadgeTooltip";
import { useIntl } from "react-intl";
import { ChatMerchant, ChatPipeline } from "../../interfaces/Chat/Chat";
import { useCustomeStore } from "../../stores/CustomeStore";
import IconTooltip from "../General/IconTooltip";
import { returnIncomingCall, returnMaps, returnMissedCall } from "../General/ChatElement";
import LabelTooltip from "../General/LabelTooltip";

interface ChatListItemProps {
    keyChatRoom: string
    type: string
    idChat: string
}

const ChatListItem: FC<ChatListItemProps> = ({ keyChatRoom, type, idChat }) => {
    const {
        messageNotifications, setMessageNotifications, listChatGroupParticipants,
        setPhoneNumber, setShowChat, phoneNumber, listFilterChat,
        listChatMessages, setMessages, setMode, listChatRooms, setIsOpenCheckBoxForward,
        setScrollToId, searchSidebar, setListChatRooms, setWindowActive,
        setSelectChatWindow, selectChatWindow, setIsOpenDetailContact,
        setMessage, selectedChatPhone, setChatSelectedPipeline, listChatAgents,
    } = useChatStore()
    const user = useUser()
    const { settings } = useSettingsStore()
    const { companyId } = useCustomeStore()
    const [isHovered, setIsHovered] = useState(false);
    const [attachmentCaption, setAttachmentCaption] = useState<string>('')
    const intl = useIntl()
    const dataChatRoom = type === 'contact' ? listChatRooms[keyChatRoom] : listFilterChat[keyChatRoom + "-" + type + "-" + idChat]
    const key = `${dataChatRoom.roomPhone}-${dataChatRoom.as}`

    const handleMouseOver = () => {
        setIsHovered(true);
    }

    const handleMouseOut = () => {
        setIsHovered(false);
    }

    const handleContactClick = async () => {
        setWindowActive('chat')
        setIsOpenCheckBoxForward(false)
        const { messageNotifications } = useChatStore.getState();

        setMessage('')
        setIsOpenDetailContact(false)
        if (listChatMessages[key] && listChatMessages[key].length > 0) {
            setMessages(() => listChatMessages[key])
        } else {
            setMessages(() => [])
        }

        setListChatRooms((prevListChatRooms) => ({
            ...prevListChatRooms,
            [keyChatRoom]: {
                ...prevListChatRooms[keyChatRoom],
                selected: true
            }
        }));

        setShowChat(true)
        setPhoneNumber(key)
        const { [key]: removedItem, ...rest } = messageNotifications;

        if (searchSidebar) {
            setMode('search')
            setScrollToId(dataChatRoom.chat.id)
        } else {
            setMode('normal')
        }

        setMessageNotifications(() => rest);
        setChatSelectedPipeline({} as ChatPipeline);
        focusChatInput()
    }

    const latestMessage = dataChatRoom.chat.message

    useEffect(() => {
        if (dataChatRoom.chat.attachmentName !== '' && dataChatRoom.chat.attachmentName !== null && dataChatRoom.chat.attachmentName !== undefined) {
            if (
                dataChatRoom.chat.attachmentName!.endsWith('.jpg') ||
                dataChatRoom.chat.attachmentName!.endsWith('.png') ||
                dataChatRoom.chat.attachmentName!.endsWith('.jpeg') ||
                dataChatRoom.chat.attachmentName!.endsWith('.gif')
            ) {
                const attachmentCaption = 'Image';
                setAttachmentCaption(() => attachmentCaption);
            } else if (dataChatRoom.chat.attachmentName!.endsWith('.mp4') || dataChatRoom.chat.attachmentName!.endsWith('.mov')) {
                const attachmentCaption = 'Video';
                setAttachmentCaption(() => attachmentCaption);
            } else {
                setAttachmentCaption(() => dataChatRoom.chat.attachmentName!.slice(0, 40) + '...');
            }
        } else {
            setAttachmentCaption(() => '');
        }
    }, [dataChatRoom])

    const handleClickChatWindow = () => {
        if (selectChatWindow.some(item => `${item.phone}-${item.as}` === key)) {
            setSelectChatWindow([...selectChatWindow.filter(item => `${item.phone}-${item.as}` !== key)])
        } else {
            setSelectChatWindow([...selectChatWindow, { name: dataChatRoom.roomName, phone: dataChatRoom.roomPhone, as: dataChatRoom.as }])
        }
    }

    const isShowBadge = () => {
        if (companyId.mlc === user.data.company_id && dataChatRoom.as === '6287722275252') {
            return false
        }

        return true
    }

    const selected = phoneNumber === key
    const isConnected = user.data.company_id === companyId.giaGroup ? true : selectedChatPhone.find(item => item.phone === dataChatRoom.as)?.connected
    const isFromMe = dataChatRoom.chat.fromMe
    const labels = dataChatRoom?.labels?.map((label: any) => ({ text: label.name, color: label.color })) || [];

    return (
        <>
            <div className={`${isShowChatRoom(settings, listChatAgents, dataChatRoom, user) ? 'd-flex flex-stack' : 'd-none'} py-4 px-3 ${isConnected ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'} ${selected ? 'rounded' : ''}`} onClick={(e) => isConnected ? handleContactClick() : e.stopPropagation()} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} style={{ width: '100%', minWidth: '0px', background: `${selected ? '#F1F2F5' : ''}` }}>
                <span className='d-flex gap-2 align-items-center' style={{ marginRight: 4 }}>
                    {
                        selectChatWindow.length > 0 &&
                        <div className="form-check form-check-custom form-check-solid" onClick={(e) => { e.stopPropagation(); handleClickChatWindow() }}>
                            <input className="form-check-input" type="checkbox" checked={selectChatWindow.some((item: ChatWindowData) => `${item.phone}-${item.as}` === key)} />
                        </div>
                    }

                    {
                        type === 'contact' &&
                        <div className='symbol symbol-45px symbol-circle'>
                            <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                                <img src={toAbsoluteUrl('/media/logos/logo-wooblazz.png')} className='symbol symbol-45px symbol-circle img-fluid' style={{ padding: "10px" }} alt='profile' />
                            </span>
                        </div>
                    }
                </span>
                <div style={{ width: '100%', minWidth: '0px' }}>
                    <div className="d-flex gap-2 align-items-center">
                        {
                            selectedChatPhone.length > 1 &&
                            <OverlayTrigger
                                key={`bullet-${dataChatRoom.chat.id}`}
                                placement='top'
                                overlay={
                                    <Tooltip id='tooltip-labels'>
                                        <span><b>{dataChatRoom.as}</b></span><br />
                                        <span>{selectedChatPhone.find(item => item.phone === dataChatRoom.as)?.ownersName.join(', ')}</span>
                                    </Tooltip>
                                }
                            >
                                <span className="bullet bullet-dot h-10px w-10px" style={{ backgroundColor: dataChatRoom.color }}></span>
                            </OverlayTrigger>
                        }

                        <span className='fs-5 fw-bolder' style={(isHovered && isConnected) ? { color: '#009EF7' } : { color: 'black' }}>
                            {
                                dataChatRoom.roomPhone === user.data.chat_phone ? user.data.name + ' (You)' : dataChatRoom.roomName ? dataChatRoom.roomName : dataChatRoom.roomPhone
                            }
                        </span>

                        {
                            settings.chat_show_merchant_pic && dataChatRoom.merchants?.length! > 0 && isShowBadge() &&
                            <BadgeTooltip tooltipText={[...new Set(dataChatRoom.merchants.map(p => p.PIC.name))].join(', ')} badgeClass='badge-light-success' style={{ maxWidth: '100px', margin: '0px !important' }}>
                                {[...new Set(dataChatRoom.merchants.map(p => p.PIC.name))].join(', ')}
                            </BadgeTooltip>
                        }

                        {
                            settings.chat_show_lead_pic && dataChatRoom.pipelines?.length! > 0 && isShowBadge() &&
                            <BadgeTooltip tooltipText={[...new Set(dataChatRoom.pipelines.map(p => p.PIC.name))].join(', ')} badgeClass="badge-light-success" style={{ maxWidth: '100px', margin: '0px !important' }} >
                                {[...new Set(dataChatRoom.pipelines.map(p => p.PIC.name))].join(', ')}
                            </BadgeTooltip>
                        }

                        {
                            labels.length > 0 && (
                                <LabelTooltip data={labels}>
                                    {labels}
                                </LabelTooltip>
                            )
                        }
                    </div>
                    {
                        dataChatRoom.merchants.length > 0 &&
                        <>
                            <p className='fs-7 fst-italic text-gray-600 mb-2'>
                                {
                                    dataChatRoom.merchants.map((data: ChatMerchant) => data.name).join(', ')
                                }
                            </p>
                        </>
                    }
                    <div
                        className={`fw-bold d-flex align-items-center ${!selected && 'text-gray-400'}`}
                        style={{ width: '100%', minWidth: 0 }}
                    >
                        {isFromMe && (
                            <span className="me-1" style={{ display: "contents" }}><i className="fas me-1 fs-9 fa-check-double"></i>{intl.formatMessage({ id: 'FORM.LABEL.YOU' })}:</span>
                        )}

                        {attachmentCaption === 'Image' && latestMessage && <i className="fas fa-image me-1"></i>}
                        {attachmentCaption === 'Video' && latestMessage && <i className="fas fa-video me-1"></i>}

                        {
                            latestMessage && (
                                latestMessage === '{{MISSED CALL}}' || latestMessage === '{{MISSED VOICE CALL}}' ? returnMissedCall(dataChatRoom.chat, intl) :
                                    (latestMessage === '{{INCOMING CALL}}' || latestMessage === '{{ACCEPTED CALL}}') ? returnIncomingCall(dataChatRoom.chat, intl) :
                                        latestMessage.includes('[User sends location]') ? returnMaps(dataChatRoom.chat, listChatGroupParticipants, dataChatRoom, intl, "chatRoom") :
                                            <span className="text-ellipsis" dangerouslySetInnerHTML={{ __html: formatText(latestMessage, listChatGroupParticipants, dataChatRoom, true, false, 1) }}></span>
                            )
                        }

                        {dataChatRoom.chat.attachmentName && !latestMessage && (
                            <>
                                {attachmentCaption === 'Image' && <i className="fas fa-image me-1"></i>}
                                {attachmentCaption === 'Video' && <i className="fas fa-video me-1"></i>}
                                {attachmentCaption !== 'Image' && attachmentCaption !== 'Video' && <i className="fas fa-file me-1"></i>}
                                <span>{attachmentCaption}</span>
                            </>
                        )}
                    </div>
                </div>
                <span style={{ marginLeft: 4 }}>
                    <div className='d-flex flex-column align-items-end'>
                        <span className={`${!selected ? 'text-muted' : 'fw-bolder'} fs-7 mb-1`}>
                            {
                                moment(dataChatRoom.chat.receivedAt).isSame(moment(), 'd')
                                    ? moment(dataChatRoom.chat.receivedAt).format('HH:mm')
                                    : moment(dataChatRoom.chat.receivedAt).isSame(moment().subtract(1, 'days'), 'd')
                                        ? 'Yesterday'
                                        : moment(dataChatRoom.chat.receivedAt).format('DD/MM/YYYY')
                            }
                        </span>
                        <div className="d-flex gap-2 align-items-center">
                            {
                                messageNotifications[keyChatRoom]?.unreadCount === null ?
                                    <span className='badge badge-sm badge-circle badge-success'></span>
                                    :
                                    messageNotifications[keyChatRoom]?.unreadCount! > 0 && !searchSidebar &&
                                    <span className='badge badge-sm badge-circle badge-success'>
                                        {
                                            messageNotifications[keyChatRoom].unreadCount
                                        }
                                    </span>
                            }
                            {
                                listChatAgents[key] && (
                                    listChatAgents[key][listChatAgents[key].length - 1]?.state === 'active' ?
                                        <IconTooltip tooltipText={'Session: Active'}>
                                            <i className="fas fa-user-check text-primary"></i>
                                        </IconTooltip>
                                        : listChatAgents[key][listChatAgents[key].length - 1]?.state === 'idle' ?
                                            <IconTooltip tooltipText={'Session: Idle'}>
                                                <i className="fas fa-user-shield text-info"></i>
                                            </IconTooltip>
                                            : listChatAgents[key][listChatAgents[key].length - 1]?.state === 'waiting' ?
                                                <IconTooltip tooltipText={'Session: Waiting'}>
                                                    <i className="fas fa-user-clock text-warning"></i>
                                                </IconTooltip>
                                                :
                                                <></>
                                )
                            }
                        </div>
                    </div>
                </span>
            </div>
        </>
    )
}

export { ChatListItem }